import React from 'react';
import { Calendar, Loader } from 'lucide-react';
import type { GetChronologyWidgetData } from '../../../types/agentWidgets';

interface Props {
  data: GetChronologyWidgetData;
}

export const GetChronologyWidget: React.FC<Props> = ({ data }) => {
  const isProcessing = data.status === 'PROCESSING';

  return (
    <div className="mt-1.5 flex items-center gap-2 text-[11px] bg-amber-50/70 dark:bg-amber-900/10 rounded px-2 py-1.5">
      <Calendar className="h-3 w-3 text-amber-500 dark:text-amber-400 flex-shrink-0" />
      <span className="font-medium text-amber-700 dark:text-amber-300">
        Chronology
      </span>
      {isProcessing ? (
        <span className="flex items-center gap-1 text-[10px] text-amber-500">
          <Loader className="h-2.5 w-2.5 animate-spin" />
          Processing
        </span>
      ) : (
        <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400">
          {data.status?.replace(/_/g, ' ').toLowerCase() || 'available'}
        </span>
      )}
    </div>
  );
};
